export default __webpack_public_path__ + "static/media/stack.f58eb7ee.svg";